var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new"},[_vm._l((_vm.componentList),function(item,index){return _c(item.name,{key:index,tag:"component"})}),_c('div')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }